
export default class RepeatDefinition {
  constructor(args = { repeat: 1, skip: 0 }) {
    this.repeat = args.repeat;
    this.skip = args.skip;
  }
}